<script setup lang="ts">
import { AppMarkdownWrapper } from '@libs/ui';

import ActivityDescriptionMarkdownStyles from './ActivityDescriptionMarkdownStyles.vue';

interface ActivityMainDescriptionProps {
  description: string;
}

const props = defineProps<ActivityMainDescriptionProps>();
</script>

<template>
  <div class="activity-description">
    <ActivityDescriptionMarkdownStyles :opening-paragraph="false">
      <AppMarkdownWrapper :source="props.description" />
    </ActivityDescriptionMarkdownStyles>
  </div>
</template>
